import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NotificationBell from './NotificationBell';

const NAV = [
  { to: '/dashboard',    label: 'Dashboard',       icon: '⊞', group: 'main' },
  { to: '/add-tiep',     label: 'Add TIEP Goods',  icon: '+', group: 'mgmt' },
  { to: '/issue-goods',  label: 'Issue Goods',     icon: '↗', group: 'mgmt' },
  { to: '/tiep-goods',   label: 'TIEP Goods',      icon: '☰', group: 'mgmt' },
  { to: '/mud-form',     label: 'MUD Form',        icon: '⎙', group: 'mgmt' },
];
const ADMIN_NAV = [
  { to: '/admin/users',  label: 'User Management', icon: '👥', group: 'admin' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const initials = (user?.full_name || user?.username || '?')
    .split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  const SidebarInner = () => (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      {/* Header */}
      <div style={{ padding:'18px 16px 14px', borderBottom:'1px solid rgba(255,255,255,.1)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div>
          <div style={{ fontSize:10, fontWeight:700, letterSpacing:2, color:'#14b8a6', textTransform:'uppercase' }}>TIEP System</div>
          <div style={{ color:'#fff', fontWeight:700, fontSize:14, marginTop:2 }}>Guarantee Tracker</div>
        </div>
        <NotificationBell />
      </div>

      {/* Nav */}
      <nav style={{ flex:1, padding:'12px 8px', overflowY:'auto' }}>
        <div style={{ fontSize:10, fontWeight:700, letterSpacing:1.5, color:'rgba(255,255,255,.3)', padding:'8px 8px 4px', textTransform:'uppercase' }}>Main</div>
        {NAV.filter(n => n.group === 'main').map(n => <SidebarLink key={n.to} {...n} />)}

        <div style={{ fontSize:10, fontWeight:700, letterSpacing:1.5, color:'rgba(255,255,255,.3)', padding:'16px 8px 4px', textTransform:'uppercase' }}>Management</div>
        {NAV.filter(n => n.group === 'mgmt').map(n => <SidebarLink key={n.to} {...n} />)}

        {user?.role === 'admin' && <>
          <div style={{ fontSize:10, fontWeight:700, letterSpacing:1.5, color:'rgba(255,255,255,.3)', padding:'16px 8px 4px', textTransform:'uppercase' }}>Administration</div>
          {ADMIN_NAV.map(n => <SidebarLink key={n.to} {...n} />)}
        </>}
      </nav>

      {/* User */}
      <div style={{ borderTop:'1px solid rgba(255,255,255,.1)', padding:'10px 8px' }}>
        <NavLink to="/profile" onClick={() => setMobileOpen(false)}
          style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 10px', borderRadius:8, textDecoration:'none', color:'rgba(255,255,255,.8)' }}
          className={({ isActive }) => isActive ? 'nav-item-active' : ''}>
          <div style={{ width:32, height:32, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, color:'#fff', flexShrink:0, overflow:'hidden' }}>
            {user?.avatar_url ? <img src={user.avatar_url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : initials}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:12, fontWeight:600, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.full_name || user?.username}</div>
            <div style={{ fontSize:10, color:'rgba(255,255,255,.4)', textTransform:'capitalize' }}>{user?.role}</div>
          </div>
        </NavLink>
        <button onClick={handleLogout}
          style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'7px 10px', background:'transparent', border:'none', color:'rgba(255,255,255,.4)', fontSize:12, cursor:'pointer', borderRadius:8, fontFamily:'inherit' }}>
          ⎋ Sign Out
        </button>
      </div>
    </div>
  );

  const SidebarLink = ({ to, label, icon }) => (
    <NavLink to={to} onClick={() => setMobileOpen(false)}
      style={({ isActive }) => ({
        display:'flex', alignItems:'center', gap:10, padding:'9px 10px', borderRadius:8,
        textDecoration:'none', fontSize:13, fontWeight:500, marginBottom:2,
        background: isActive ? 'var(--teal)' : 'transparent',
        color: isActive ? '#fff' : 'rgba(255,255,255,.6)',
        transition:'all 0.15s',
      })}>
      <span style={{ fontSize:16, lineHeight:1 }}>{icon}</span> {label}
    </NavLink>
  );

  return (
    <div style={{ display:'flex', minHeight:'100vh' }}>
      {/* Desktop sidebar */}
      <aside style={{ width:220, background:'var(--navy)', flexShrink:0, position:'fixed', top:0, left:0, bottom:0, zIndex:30, display:'flex', flexDirection:'column' }}
        className="desktop-sidebar">
        <SidebarInner />
      </aside>

      {/* Mobile top bar */}
      <div style={{ display:'none', position:'fixed', top:0, left:0, right:0, zIndex:30, background:'var(--navy)', padding:'10px 16px', alignItems:'center', justifyContent:'space-between' }}
        className="mobile-topbar">
        <div>
          <span style={{ fontSize:10, fontWeight:700, color:'var(--teal2)', letterSpacing:2 }}>TIEP</span>
          <span style={{ color:'#fff', fontWeight:700, fontSize:13, marginLeft:8 }}>Guarantee Tracker</span>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <NotificationBell />
          <button onClick={() => setMobileOpen(!mobileOpen)}
            style={{ background:'transparent', border:'none', color:'#fff', fontSize:20, cursor:'pointer', padding:'2px 6px' }}>
            ☰
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div style={{ position:'fixed', inset:0, zIndex:40, display:'flex' }}>
          <div style={{ width:240, background:'var(--navy)', display:'flex', flexDirection:'column' }}><SidebarInner /></div>
          <div style={{ flex:1, background:'rgba(0,0,0,.5)' }} onClick={() => setMobileOpen(false)} />
        </div>
      )}

      {/* Main content */}
      <div style={{ flex:1, marginLeft:220, minHeight:'100vh', display:'flex', flexDirection:'column' }} className="main-content">
        <div style={{ paddingTop:0 }} className="content-pad">
          <Outlet />
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .desktop-sidebar { display: none !important; }
          .mobile-topbar { display: flex !important; }
          .main-content { margin-left: 0 !important; }
          .content-pad { padding-top: 52px !important; }
        }
      `}</style>
    </div>
  );
}
